import { render, staticRenderFns } from "./uploadTips.vue?vue&type=template&id=ffb6ffe0"
import script from "./uploadTips.vue?vue&type=script&lang=js"
export * from "./uploadTips.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports